import styled from 'styled-components';
import Slider, { Settings } from 'react-slick';
import React, { useEffect, useState } from 'react';

import { Feedback } from '@shared/constants/feedback';
import { FeedbackCard } from '@components/molecules';
import { useIsClient } from '@hooks/useIsClient';

type PhotoSliderProps = {
  content: Feedback[];
};

function PhotoSlider({ content }: PhotoSliderProps) {
  const isClient = useIsClient();
  const [slides, setSlides] = useState(1);

  useEffect(() => {
    if (window?.innerWidth) {
      setSlides(1);
      if (window.innerWidth > 750) setSlides(2);
      if (window.innerWidth > 1140) setSlides(3);
    }
  }, [isClient && window.innerWidth]);

  const settings: Settings = {
    dots: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    pauseOnFocus: true,
    autoplaySpeed: 5000,
    slidesToShow: slides,
    slidesToScroll: slides,
    pauseOnDotsHover: true,
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {content.map((feedback, index) => (
          <Wrapper key={index}>
            <FeedbackCard
              fontSize={14}
              lineHeight={18}
              {...feedback}
              isCenter
            />
          </Wrapper>
        ))}
      </Slider>
    </div>
  );
}

const Wrapper = styled.div`
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;

export default PhotoSlider;
